import posthog from "posthog-js";

let initialized = false;

/** Call once before render. No-ops when `BUN_PUBLIC_POSTHOG_KEY` is missing. */
export function initPostHog(): void {
  if (initialized) return;
  const key = process.env.BUN_PUBLIC_POSTHOG_KEY;
  if (!key) return;

  const apiHost = process.env.BUN_PUBLIC_POSTHOG_HOST;
  posthog.init(key, {
    ...(apiHost ? { api_host: apiHost } : {}),
    defaults: "2026-01-30",
  });
  initialized = true;
}

/** Safe to call from handlers; only sends when PostHog was initialized. */
export function capturePostHog(event: string, properties?: Record<string, unknown>): void {
  if (!initialized) return;
  try {
    posthog.capture(event, properties);
  } catch {
    /* ignore */
  }
}
